import '../../styles-new/pages/context/main-page.scss';
import { BecomeColumnistPopup } from '../context/become-columnist-popup';
import { ColumnistDropdown } from '../context/columnist-dropdown';

document.addEventListener('DOMContentLoaded', () => {
  const selects = document.querySelectorAll('.context-select');
  const selectedItems = {
    category: null,
    topic: null
  };

  // Initialize all columnist dropdowns
  document.querySelectorAll('.context-select_columnist').forEach(select => {
    new ColumnistDropdown(select);
  });
  new BecomeColumnistPopup();

  selects.forEach((select, index) => {
    const btn = select.querySelector('.context-select__btn');
    const dropdown = select.querySelector('.context-select-dropdown');
    const items = dropdown.querySelectorAll('.context-select-dropdown__item');
    const textSpan = btn.querySelector('span');
    const selectType = index === 0 ? 'category' : 'topic';

    // Toggle dropdown on button click
    btn.addEventListener('click', (e) => {
      e.stopPropagation();

      // Close other open selects
      selects.forEach(otherSelect => {
        if (otherSelect !== select) {
          otherSelect.classList.remove('context-select_active');
          otherSelect.querySelector('.context-select-dropdown').style.display = 'none';
        }
      });

      // Toggle current select
      select.classList.toggle('context-select_active');
      dropdown.style.display = select.classList.contains('context-select_active') ? 'flex' : 'none';
    });

    // Handle item selection
    items.forEach(item => {
      item.addEventListener('click', () => {
        // Remove active class from all items
        items.forEach(i => i.classList.remove('context-select-dropdown__item_active'));
        // Add active class to selected item
        item.classList.add('context-select-dropdown__item_active');
        // Update button text
        textSpan.textContent = item.querySelector('.context-select-dropdown__item-text').textContent;
        // Add selected class to select
        select.classList.add('context-select_selected');
        // Store selected item
        selectedItems[selectType] = {
          text: item.querySelector('.context-select-dropdown__item-text').textContent,
          element: item
        };
        // Close dropdown
        select.classList.remove('context-select_active');
        dropdown.style.display = 'none';
      });
    });
  });

  // Close dropdowns when clicking outside
  document.addEventListener('click', () => {
    selects.forEach(select => {
      select.classList.remove('context-select_active');
      select.querySelector('.context-select-dropdown').style.display = 'none';
    });
  });
});
